import { render, staticRenderFns } from "./ProvincialOfficerManage.vue?vue&type=template&id=b0201b8a&"
import script from "./ProvincialOfficerManage.vue?vue&type=script&lang=js&"
export * from "./ProvincialOfficerManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports